export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f7306778ced050766c5258095dfbfce3a9320973c&name=fetchTypeahead!'